<template>
  <v-container fluid>
    <v-app-bar app>
      <v-btn icon to="/signup">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>

      <v-toolbar-title>{{language.terms_and_conditions}}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>

    <div class="content" v-html="content"></div>
    <!-- <v-list two-line class="list-view" v-if="items.length > 0">
      <template v-for="(item) in items">
        <v-list-tile class="list-view-item" :key="item.title" avatar ripple>
          <v-list-tile-content>
            <v-list-tile-title :class="'pack-title'">{{ item.oficina }}</v-list-tile-title>

            <table
              v-bind:class="item.longitud !=='' && item.latitud !=='' ? 'pack-list-table mb-3' : 'has-btn pack-list-table'"
            >
              <tr>
                <th colspan="2">Direccion</th>
              </tr>
              <tr>
                <td colspan="2" style="text-align: left;padding: 0px 15px 10px 16px;">
                  <v-list-tile-sub-title class="mt-3 no-hidden-text">{{ item.direccion }}</v-list-tile-sub-title>
                </td>
              </tr>
              <tr>
                <th>Email</th>
                <td>{{item.email_address}}</td>
              </tr>
              <tr v-if="item.telefono1 !==''">
                <th>Telefono</th>
                <td>{{item.telefono1}}</td>
              </tr>
              <tr v-if="item.telefono2 !==''">
                <th>Telefono</th>
                <td>{{item.telefono2}}</td>
              </tr>
              <tr v-if="item.horario !==''">
                <th>Horario</th>
                <td>{{item.horario}}</td>
              </tr>
            </table>
            <v-btn
              color="info"
              class="mb-3 mt-1"
              block
              v-if="item.longitud !=='' && item.latitud !==''"
              @click="openMap(item.longitud,item.latitud,item.oficina)"
            >Ver en el mapa</v-btn>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>-->
    <!-- <div v-else>
      <div v-if="noData">
        <img src="../assets/nodatos.jpg" class="noData" alt />
        <div class="font-weight-black text-center">
          {{language.you_have_no_data_available}}
        </div>
      </div>
      <v-progress-circular :size="90" color="blue" indeterminate class="loading-center"></v-progress-circular>
    </div>-->
  </v-container>
</template>

<script>
// import Helpers from "../utils/helpers";
import Server from "../utils/server";
export default {
  created() {
    this.getPacks();
  },
  mounted() {
    this.getPacks();
  },
  data() {
    return {
      clipped: false,
      items: [],
      content: "",
      currentUser: undefined
    };
  },
  computed: {
    login: function() {
      return this.$store.getters.login;
    },
    user: function() {
      return this.$store.getters.user;
    }
    ,
    profile: function () {
      return this.$store.getters.profile;
    },
    language: function () {
      return this.$store.getters.language;
    },
  },
  methods: {
    openMap(log, lat, title) {
      window.MobileApi.openLocationInMap(log, lat, title);
    },
    getPacks() {
      var formData = new FormData();
      // formData.append("text1", this.currentUser.userName);
      // formData.append("text3", this.currentUser.pushId);
      // formData.append("device", window.MobileApi.device);
      this.$http.get(Server.TermsConditions, formData).then(
        response => {
          if (response.body) {
            this.content = response.body;
          } else {
            this.noData = true;
          }
        },
        () => {
          this.error = true;
          this.msj = this.language.an_error_has_occurred_try_again_later;
        }
      );
    }
  },
  name: "App"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
